module.exports = __webpack_public_path__ + "static/media/link-method.5b9df584.svg";